// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"869":"4f07b4b4","6148":"cc2f988b"}[chunkId] + ".chunk.css";
};